import { useGetCustomerCallerIdQuery } from '@/common/infrastructure/gql/generated/schema';
import { ContactInfoType, ALLOWED_CALLER_ID_TYPES } from '@/customers/application/types/CustomerTypes';

// Type for customer data from listCustomersAutocomplete
type CustomerWithContacts = {
  id?: number | null;
  companyName?: string | null;
  contacts?: Array<{
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    contactInformation?: Array<{
      id?: number | null;
      type?: string | null;
      contact?: string | null;
    }> | null;
  }> | null;
};

export const useGetCustomerCallerId = (customerId?: number, customerData?: CustomerWithContacts) => {
  const skip = !customerId || isNaN(customerId);

  // Use customer data if provided, otherwise fall back to API call
  const { data, loading, error } = useGetCustomerCallerIdQuery({
    variables: { customerId: customerId! },
    skip: skip || !!customerData, // Skip API call if we have customer data
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first' // Keep using cache for subsequent fetches
  });

  // Use customer data if available, otherwise use API response
  const customerDetails = customerData || data?.customerDetails;
  const contacts = customerData?.contacts ?? data?.customerDetails?.contacts ?? [];

  // Filter contactInformation with Mobile, Landline or E-mail to show only information related to CallerId
  const filteredContacts = contacts
    .filter((contact) =>
      contact.contactInformation?.some((info) => info.type && ALLOWED_CALLER_ID_TYPES.includes(info.type as ContactInfoType))
    )
    .filter((contact, index, self) => self.findIndex((c) => c.id === contact.id) === index);

  return {
    customerDetails,
    loading: customerData ? false : loading,
    error: customerData ? null : error,
    contacts: filteredContacts
  };
};
